import BaseDB from 'libs/DB/BaseDB'

const dataDB = new BaseDB('allowedSenderDB', {
  version: 1,
  key: 'email',
  expireDuration: null,
  skipPreload: false,
})

export default dataDB
